'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:CustomerDetailsCtrl
 * @description
 * # CustomerDetailsCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('CustomerDetailsCtrl', function($scope, $http, $location, $routeParams,
    CustomerService, FlashService, cfpLoadingBar) {

    var customerVm = this;

    customerVm.id = $routeParams.customerId;
    customerVm.homeList = [];
    customerVm.homesExist = false;

    customerVm.GetCustomer = getCustomer;
    customerVm.editCustomerHome = editCustomerHome;

    activate();

    function activate() {
      customerVm.GetCustomer(customerVm.id);
    }

    function getCustomer(id) {
      cfpLoadingBar.start();
      CustomerService.GetById(id).
      then(getCustomerSuccess, responseError)
      .finally(requestComplete);
    }

    function getCustomerHomes(id) {
      cfpLoadingBar.start();
      CustomerService.GetHomes(id).
      then(function(response) {
          customerVm.homeList = response;
          cfpLoadingBar.complete();
      }, function (error) {
        FlashService.Error('Network Error. Try reloading the page', false);
      });
    }

    function editCustomerHome(home) {
        $location.path('/homes/edit/' + home.id);
    }

    function getDirectionsUrl(customerObj) {
      var baseDirectionsUrl = 'https://maps.google.com?daddr=';
      return baseDirectionsUrl + customerObj.address + '+' + customerObj.town + '+' + customerObj.postcode;
    }

    function getCustomerSuccess (response) {
        customerVm.customer = response;
        customerVm.firstName = customerVm.customer.firstName;
        customerVm.directionsUrl = getDirectionsUrl(customerVm.customer);
        customerVm.homeList = customerVm.customer.homes;
        customerVm.homesExist = customerVm.homeList.length > 0;
        customerVm.homeList.forEach(function(item) {
          item.directionsUrl = getDirectionsUrl(item);
        });
        cfpLoadingBar.complete();
    }

    function responseError (error) {
      FlashService.Error('Network Error. Try reloading the page', false);
    }

    function requestComplete() {
      cfpLoadingBar.complete();
    }

    return customerVm;

  });
